// Copyright (c) 2016 Deere & Company

import {buildNumberString} from './build-number-string';
import {getStore} from '../../store-factory';

export const buildNumber = (number, options = {}, decimalFormatKey) => {

    const decimalFormat = decimalFormatKey ?
        decimalFormatKey :
        getStore().getState().user.details.settings.general.decimalFormat.key;

    return (
        typeof number === 'undefined' || number === null ?
            '' :
            buildNumberString(decimalFormat, number, options)
    );

};

export const buildCurrency = (number, options = {}) => buildNumber(number, {
    ...options,
    minimumFractionDigits: 2
});

export const buildReportCurrency = number => buildCurrency(number ? number : 0);



// WEBPACK FOOTER //
// ./src/shared/services/build-number.js